import React from 'react';
import NotIncludedList from './components/NotIncludedList';
import DragList from './components/DragList';
import Header from './components/Header';
import Help from './components/Help';
import {
  CustomContextMenu, Wrapper, Columns, AddedColumnsWrapper
} from './styled';

// TODO: toggle menu state

const EditColumnContext = ({
  trigger, toggle, fields, setFieldVisibility, setNewOrderColumns, resetDefault, entity, testIdPrefix
}) => (
  <CustomContextMenu id={ trigger } onHide={ toggle } onShow={ toggle } data-testid={ testIdPrefix ? `${testIdPrefix}-popover` : undefined }>
    <Wrapper>
      <Header resetDefault={ resetDefault } testIdPrefix={ testIdPrefix } />
      <Columns>
        <AddedColumnsWrapper onClick={ (e) => e.stopPropagation() }>
          <DragList fields={ fields } setFieldVisibility={ setFieldVisibility } setNewOrderColumns={ setNewOrderColumns } entity={ entity } testIdPrefix={ testIdPrefix } />
          <Help />
        </AddedColumnsWrapper>
        <NotIncludedList fields={ fields } setFieldVisibility={ setFieldVisibility } entity={ entity } testIdPrefix={ testIdPrefix } />
      </Columns>
    </Wrapper>
  </CustomContextMenu>
);

export default EditColumnContext;
